import React from "react";

export default function LegalPage({ title, children }) {
  return (
    <main className="max-w-4xl mx-auto px-4 py-12 text-slate-200">
      <header className="mb-10">
        <h1 className="text-3xl font-bold tracking-tight">{title}</h1>
      </header>

      <article className="space-y-8 leading-relaxed text-base sm:text-lg">
        {children}
      </article>
    </main>
  );
}
